import { Component } from '@angular/core';
import * as fromServices from '../../../services';

@Component({
  selector: 'hdw-about-this-tool',
  templateUrl: './about-this-tool.component.html',
  styleUrls: ['./about-this-tool.component.scss']
})
export class AboutThisToolComponent {
  public refreshDate: string;
  constructor(private locationFactory: fromServices.LocationFactoryService){
     this.locationFactory.getRefreshDate().then(refreshDateResponse => {
      this.refreshDate = refreshDateResponse.refreshDate
    });
  }
}
